<template>
<div :class="['nav-item',transparent ? 'nav-item__tranparent':'nav-item__white']">
    <template v-if="!hasChild">
        <slot name="name">
            <router-link
                exact
                :active-class="activeClass"
                class="nav-item-name"
                :to="to">
                {{name}}
            </router-link>
        </slot>
    </template>

    <template v-else>
        <Popover
            :lazy="false"
            :arrow="false"
            :fixed="true"
            :visible="visible"
            placement="bottom-start"
            popoverClass="nav-popover"
        >
            <span :class="['nav-item-name', isPopoverHover?'nav-item-name__hover':'']" @mouseenter="visible=true" @mouseleave="visible=false">
                <slot name="name">
                    {{name}}
                    <svg
                        class="icon-down"
                        t="1598006321313"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8928">
                        <path d="M316.16 366.506667L512 561.92l195.84-195.413333L768 426.666667l-256 256-256-256z" p-id="8929"/>
                    </svg>
                </slot>
            </span>
            <span class="nav-item-content" slot="content" @mouseenter="onHover(true)" @mouseleave="onHover(false)">
                <slot />
            </span>
        </Popover>
    </template>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Popover } from '@gaoding/gdui';
export default {
  name: 'nav-item',
  components: {
    Popover
  },
  props: {
    name: {
      type: String,
      required: true
    },
    to: {
      type: String,
      default: '/'
    },
    activeClass: {
      type: String,
      default: ''
    },
    // 是否为透明底
    transparent: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isPopoverHover: false,
      visible: false
    };
  },

  computed: {
    hasChild() {
      return !!this.$slots.default;
    }

  },
  methods: {
    onHover(isHover) {
      this.visible = isHover;
      this.isPopoverHover = isHover;
    }

  }
};
</script>
<style scoped>
.nav-item {
  display: inline-block;
  margin-right: 48px;
}
.nav-item-name {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}
.nav-item .nav-item-name:hover::before {
  content: '';
  position: absolute;
  width: 100px;
  height: 20px;
  left: -20px;
  top: 20px;
}
.nav-item__tranparent .nav-item-name__hover {
  opacity: 1 !important;
  font-weight: 700 !important;
}
.nav-item__tranparent .nav-item-name__hover .icon-down {
  transition: transform 0.6s !important;
  transform: rotateX(180deg) !important;
}
.nav-item__tranparent .nav-item-name {
  color: white;
  fill: white;
  opacity: 0.9;
}
.nav-item__tranparent .nav-item-name .icon-down {
  margin-left: 2px;
  width: 18px;
  height: 18px;
}
.nav-item__tranparent .nav-item-name:hover {
  opacity: 1 !important;
  font-weight: 700 !important;
}
.nav-item__tranparent .nav-item-name:hover .icon-down {
  transition: transform 0.6s !important;
  transform: rotateX(180deg) !important;
}
.nav-item__white {
  display: inline-block;
  margin-right: 48px;
}
.nav-item__white .nav-item-name__hover {
  opacity: 1 !important;
  fill: #2254f4 !important;
  color: #2254f4 !important;
  font-weight: 700 !important;
}
.nav-item__white .nav-item-name__hover .icon-down {
  transition: transform 0.2s !important;
  transform: rotateX(180deg) !important;
}
.nav-item__white .nav-item-name {
  color: #444950;
  fill: #444950;
  opacity: 0.9;
}
.nav-item__white .nav-item-name .icon-down {
  width: 20px;
  height: 20px;
}
.nav-item__white .nav-item-name:hover {
  opacity: 1 !important;
  fill: #2254f4 !important;
  color: #2254f4 !important;
  font-weight: 700 !important;
}
.nav-item__white .nav-item-name:hover .icon-down {
  transition: transform 0.2s !important;
  transform: rotateX(180deg) !important;
}

</style>
